import { Route } from '@direct-frontend/modules-router';
import { Bundle } from '#pages/bundle';
import { DiscountLadderAsync } from '#pages/discountLadder';
import { GiftAsync } from '#pages/gift';
import { PriceStrategyAsync } from '#pages/priceStrategy';
import { PromoactionAsync } from '#pages/promoaction';
import { PromoactionsAsync } from '#pages/promoactions';
import { PromoactionsGiftCardFormAsync } from '#pages/promoactions';
import { PromoRecommendationFormAsync } from '#pages/promoRecommendationForm';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import {
    promoactionBundleRoute,
    promoactionDiscountLadderRoute,
    promoactionGiftCardFormRoute,
    promoactionGiftsRoute,
    promoactionPriceStrategyRoute,
    promoactionRoute,
    promoactionsRoute,
    promoRecommendationFormRoute,
} from '#shared/lib/routes';

export const promotionsRoutes = () =>
    renderWithPermission(
        'promotions',
        'read',
        <>
            <Route path={promoactionsRoute.route} element={<PromoactionsAsync />} />
            <Route path={promoactionRoute.route} element={<PromoactionAsync />} />
            <Route path={promoactionPriceStrategyRoute.route} element={<PriceStrategyAsync />} />
            <Route path={promoactionBundleRoute.route} element={<Bundle />} />
            <Route path={promoactionGiftsRoute.route} element={<GiftAsync />} />
            <Route path={promoactionGiftCardFormRoute.route} element={<PromoactionsGiftCardFormAsync />} />
            <Route path={promoactionDiscountLadderRoute.route} element={<DiscountLadderAsync />} />
            <Route path={promoRecommendationFormRoute.route} element={<PromoRecommendationFormAsync />} />
        </>
    );
